namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmIszrUrovenPristupu extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmIszrUrovenPristupuReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmIszrUrovenPristupuObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmIszrUrovenPristupuObj());
            this.detailObj.createBase({
                contentName: "detailAdmIszrUrovenPristupu",
                contentCaption: "jres:33000766",  //RC 33000766 : Úroveň přístupu agendy
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmIszrUrovenPristupu", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmIszrUrovenPristupuObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmIszrUrovenPristupuReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0} - {1}".format(this.data["agenda"] ? this.data["agenda"] : "", this.data["ixs_tre_txt"] ? this.data["ixs_tre_txt"] : "")
        }

        setSxsDetail(): string {
            return "{0}#{1}#".format((this.data.ixs_tre) ? this.data.ixs_tre.toString() : "", (this.data.agenda) ? this.data.agenda.toString() : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmIszrUrovenPristupuSaveDto, close: boolean) {
            if (this.options.newRecord == false && this.data.agenda != data.agenda) {
                this.cnt.dialogs.confirmDangerous("jres:33000759", "jres:33000760").on("yes", () => { //RC 33000760 : Opravdu si přejete změnit agendu role? Tuto akci doporučujeme dělat pouze v případě dřívějšího chybného zadání dat.
                    this.saveDataInternal(data, close);
                }) 
            } else
                this.saveDataInternal(data, close);
        }

        private saveDataInternal(data: Gordic.AdmIsl.Interface.GAdmIszrUrovenPristupuSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmIszrUrovenPristupu.upsert({ data: data }).get() as any).then((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => { this.cnt.close() })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmIszrUrovenPristupu", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmIszrUrovenPristupu.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, this.textPopis()?.toString());
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("agenda", Gordic.Prefabs.Select.szrsage(), { model: "model.agenda=value.agenda" });
            this.MakeSelectField("ixs_tre", Gordic.Prefabs.Select.ginstre(), { model: "model.ixs_tre=value.ixs_tre" })
            this.MakeSelectField("ur_pri", Gordic.Prefabs.Select.ginsurp(), { model: "model.ur_pri=value.ur_pri" })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}